import apiService from "./api";

export const getAllState = () => {
  const url = `/core/states/`;

  return apiService(url, "GET", null, true);
};

export const getUserAddress = () => {
  const url = `/core/user/address/`;

  return apiService(url, "GET", null, true);
};

export const addUserAddress = (formData: Record<string, any>) => {
  const url = `/core/user/address/`;

  return apiService(url, "POST", formData, true);
};
